<template>
  <div class="home">
    <h1>首页</h1>
    <p>欢迎来到有球之星赛事大数据分析系统！</p>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home {
  text-align: center;
  padding: 40px;
}

h1 {
  color: #42b883;
  margin-bottom: 20px;
}

p {
  font-size: 18px;
  margin-bottom: 30px;
}

a {
  color: #42b883;
  text-decoration: none;
  padding: 10px 20px;
  border: 2px solid #42b883;
  border-radius: 5px;
  transition: all 0.3s ease;
}

a:hover {
  background-color: #42b883;
  color: white;
}
</style>
